import type { Messages } from './messages';

/**
 * Copy for the design system — `src/ui/**` and the `/__ui` gallery at
 * `src/app/ui-gallery/`. Owned by the design-system author.
 *
 * Every key starts with `ui.`. Seeded verbatim from `PENDING` in
 * `src/ui/text.ts` so that object can be deleted and `ui(key)` can read
 * `t(\`ui.${key}\`)` instead. The shell's own words (`nav.*`) and the shared
 * actions (`common.*`) live in their own files and are read from there.
 */
export const ui = {
  'ui.title': 'معرض المكوّنات',
  'ui.skipToContent': 'تخطَّ إلى المحتوى',
  'ui.mainNav': 'التنقّل الرئيسي',
  'ui.more': 'المزيد',
  'ui.openMenu': 'فتح القائمة',
  'ui.closeMenu': 'إغلاق القائمة',
  'ui.breadcrumb': 'مسار التنقّل',
  'ui.copy': 'نسخ',
  'ui.copied': 'نُسخ',
  'ui.copyFailed': 'تعذّر النسخ — حدّد النص وانسخه يدويًا',
  'ui.secretSet': 'محفوظ',
  'ui.secretNotSet': 'غير مضبوط',
  'ui.secretReplace': 'استبدال',
  'ui.secretKeep': 'الإبقاء على المحفوظ',
  'ui.secretNeverShown': 'القيمة المحفوظة لا تُعرض أبدًا. اكتب قيمة جديدة لاستبدالها.',
  'ui.sortBy': 'ترتيب حسب {column}',
  'ui.pagePrevious': 'الصفحة السابقة',
  'ui.pageNext': 'الصفحة التالية',
  'ui.pageOf': 'صفحة {page} من {count}',
  'ui.pagination': 'التنقّل بين الصفحات',
  'ui.pageSize': 'في الصفحة',
  'ui.pageSizeOption': '{size} صفًّا',
  'ui.shown': 'يُعرض {shown}',
  'ui.shownOfTotal': 'يُعرض {shown} من {total}',
  'ui.errorTitle': 'تعذّر التحميل',
  'ui.optional': 'اختياري',
  'ui.required': 'مطلوب',
  'ui.clearSearch': 'مسح البحث',
  'ui.chartData': 'بيانات المخطط',
  'ui.chartEmpty': 'لا بيانات لهذه الفترة بعد',
  'ui.meterNoCap': 'بلا سقف',
  'ui.meterOf': '{value} من {max}',
  'ui.meterOver': 'تجاوز السقف',
  'ui.meterNear': 'يقترب من السقف',
  'ui.deltaUp': 'ارتفاع',
  'ui.deltaDown': 'انخفاض',
  'ui.deltaFlat': 'دون تغيير',
  'ui.typeToConfirm': 'اكتب {text} للتأكيد',
  'ui.notifications': 'الإشعارات',
  'ui.dismiss': 'إغلاق الإشعار',
  'ui.moreCount': '+{count}',
  'ui.stepOf': 'الخطوة {step} من {count}',
  'ui.sectionFlag': 'يحتاج انتباهًا',
  'ui.total': 'الإجمالي',
  'ui.legend': 'مفتاح المخطط',
  'ui.chipAdd': 'إضافة',
  'ui.chipRemove': 'إزالة {value}',
  'ui.chipAdded': 'أُضيف: {values}',
  'ui.chipRemoved': 'أُزيل: {value}',
  'ui.chipsCount': '{count} من {max}',
  'ui.chipsDuplicate': 'موجود في القائمة من قبل: {values}',
  'ui.chipsOverflow': 'القائمة لا تتّسع لأكثر من {max}، فلم يُضف: {values}',
  'ui.granted': 'ممنوحة',
  'ui.notGranted': 'غير ممنوحة',
} as const satisfies Messages<'ui'>;
